import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import {
  BLOCKS,
  INLINES,
  MARKS,
} from "@contentful/rich-text-types"

export const RichTextRenderer = ({ richTextDocument }) => {
    if (!richTextDocument) {
        return null
    }
    return documentToReactComponents(richTextDocument, options)
}

const options = {
    renderMark: {
    [MARKS.BOLD]: (children) => <span className="text-base font-medium tagline-font">{children}</span>,
    [MARKS.ITALIC]: (text) => <em>{text}</em>,
  },
  renderNode: {
    [BLOCKS.HEADING_1]: (node, children) => (
      <h1 className="text-3xl leading-tight font-bold pt-8 pb-1">{children}</h1>
    ),
    [BLOCKS.HEADING_2]: (node, children) => (
      <h2 className="text-2xl leading-snug font-semibold pt-6 pb-1">
        {children}
      </h2>
    ),
    [BLOCKS.HEADING_3]: (node, children) => (
      <h3 className="text-large leading-normal font-semibold pb-5 pb-1">
        {children}
      </h3>
    ),
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <p className="text-base font-medium font-regular leading-normal py-1 [&:not(:first-child)]:pt-3">
        {children}
      </p>
    ),
    [BLOCKS.QUOTE]: (node, children) => (
      <div className="py-2">
        <blockquote className="text-base font-medium leading-normal border-l-4 border-current pl-3">
          {children}
        </blockquote>
      </div>
    ),
    [BLOCKS.HR]: () => <hr className="my-4 border-current" />,
    [BLOCKS.UL_LIST]: (node, children) => (
      <ul className="ml-6 py-4 list-disc">{children}</ul>
    ),
    [BLOCKS.OL_LIST]: (node, children) => (
      <ol className="ml-6 py-4 list-decimal">{children}</ol>
    ),
    [BLOCKS.LIST_ITEM]: (node, children) => (
      <li className="text-base font-medium">{children}</li>
    ),
    [INLINES.HYPERLINK]: (node, children) => {
      const url = node.data.uri
      return (
        <a
          href={url}
          className="underline hover:text-foreground transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      )
    }
  },
}
